function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable array-callback-return */
import React from 'react';
import { default as CircularProgressbar, circularProgressClasses } from '@mui/material/CircularProgress';
import { Box } from "../Box/index.js";
import { Typography } from "../Typography/index.js";
import { COLOR_VARIANTS } from "../../theme/palette.theme/index.js";
import { TYPOGRAPHY_VARIANT } from "../../theme/typography.theme/index.js";
import { color } from "../../utils/index.js";
var VARIANTS = {
  LIGHT: 'light',
  DARK: 'dark'
};
var STATUS = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};
export var CircularProgress = function CircularProgress(_ref) {
  var variant = _ref.variant,
    statusPosition = _ref.statusPosition,
    statusText = _ref.statusText,
    testId = _ref.testId,
    id = _ref.id;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      flexDirection: statusPosition === STATUS.VERTICAL ? 'column' : '',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: 'relative',
      display: 'flex'
    },
    "data-testid": testId,
    id: id
  }, /*#__PURE__*/React.createElement(CircularProgressbar, {
    variant: "determinate",
    sx: {
      color: variant === VARIANTS.DARK ? color(COLOR_VARIANTS.WHITE) : color(COLOR_VARIANTS.AQUA30),
      opacity: variant === VARIANTS.DARK ? '0.4' : ''
    },
    size: statusPosition === STATUS.HORIZONTAL ? 15 : 40,
    thickness: 6
    // {...props}
    ,
    value: 100
  }), /*#__PURE__*/React.createElement(CircularProgressbar, {
    sx: _defineProperty(_defineProperty({
      color: variant === VARIANTS.DARK ? color(COLOR_VARIANTS.WHITE) : color(COLOR_VARIANTS.AQUA100),
      animationDuration: '2500ms',
      position: 'absolute',
      left: 0
    }, "& .".concat(circularProgressClasses.circle), {
      strokeLinecap: 'round',
      animation: 'circularEffect 2.5s ease-in-out infinite'
    }), '@keyframes circularEffect', {
      '0%': {
        strokeDasharray: '1px,200px',
        strokeDashoffset: 0
      },
      '50%': {
        strokeDasharray: '25px,200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '25px,200px',
        strokeDashoffset: '-117px'
      }
    }),
    size: statusPosition === STATUS.HORIZONTAL ? 15 : 40,
    thickness: 6
  })), statusText && /*#__PURE__*/React.createElement(Typography, {
    variant: TYPOGRAPHY_VARIANT.BODY2,
    color: variant === VARIANTS.DARK ? COLOR_VARIANTS.WHITE : COLOR_VARIANTS.GREYCHATEAU,
    component: "p",
    sx: {
      marginTop: statusPosition === STATUS.VERTICAL ? '12px' : '',
      marginLeft: statusPosition === STATUS.HORIZONTAL ? '9px' : ''
    }
  }, statusText));
};